export const SERVER_SIDE_EVENT_NAME = 'NotifyUserAsync';

export const SERVER_SIDE_EVENT_NAME_NOTIFICATIONS = 'SendNotificationsAsync';
